export default "__VITE_ASSET__ByI2tAzs__"